import { defaultChains } from "wagmi"
import { InjectedConnector } from "wagmi/connectors/injected"

export const connectors = [
  new InjectedConnector({
    chains: [defaultChains[0]],
    options: {
      shimDisconnect: true,
      shimChainChangedDisconnect: true,
    },
  }),
  // todo add more connectors
]
